/**
 *
 * UserEditForm
 *
 */

import { Component } from "react";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import GlobalMessages from "messages/messages";
import DataTable from "basicComponents/DataTable/DataTable";
import * as PropTypes from "prop-types";
import messages from "./messages";
import userMessages from "containers/UserEditPage/messages";
import PracticeChange from "components/PracticeChange/PracticeChange";

const NewHeader = styled.div`
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: ${({ theme }) => theme.fontSize.large};
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

class PracticeInfo extends Component {
  static propTypes = {
    practice: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    practices: PropTypes.array,
    onClick: PropTypes.func,
    multiColumnPracticeInfo: PropTypes.any,
  };

  render() {
    const { practice, practices, onClick } = this.props;

    return (
      <ComponentWrapper>
        <Wrapper>
          <Content>
            <NewHeader>
              <FormattedMessage {...messages.practiceInfo} />
              <PracticeChange practices={practices} onClick={onClick}>
                <FormattedMessage {...userMessages.selectPractice} />
              </PracticeChange>
            </NewHeader>
            <DataTableWrapper
              style={{background:"white"}}
            >
              <DataTable
                multiColumnPracticeInfo={this.props.multiColumnPracticeInfo}
                disabled={this.props.disabled}
                editIcon
                handleConfirm={this.handleConfirm}
                items={[
                  [
                    {
                      label: (
                        <FormattedMessage
                          {...GlobalMessages.practiceName_colon}
                        />
                      ),
                      value: practice.name ? (
                        practice.name
                      ) : (
                        <FormattedMessage {...GlobalMessages.unavailable} />
                      ),
                      disableIcon: true,
                      id: "practiceName",
                      hideDeleteIcon: true,
                    },
                    {
                      label: <FormattedMessage {...GlobalMessages.street} />,
                      value:
                        practice.street && practice.house_nr ? (
                          `${practice.street}`
                        ) : (
                          <FormattedMessage {...GlobalMessages.unavailable} />
                        ),
                      disableIcon: true,
                      hideDeleteIcon: true,
                    },
                    {
                      label: <FormattedMessage {...GlobalMessages.zipcode} />,
                      value: practice.zipcode ? (
                        practice.zipcode
                      ) : (
                        <FormattedMessage {...GlobalMessages.unavailable} />
                      ),
                      disableIcon: true,
                      hideDeleteIcon: true,
                    },

                    {
                      label: <FormattedMessage {...GlobalMessages.state} />,
                      value:
                        practice.state && practice.isoCountry ? (
                          `${practice.state}`
                        ) : (
                          <FormattedMessage {...GlobalMessages.unavailable} />
                        ),
                      disableIcon: true,
                      hideDeleteIcon: true,
                    },
                    {
                      label: (
                        <FormattedMessage
                          {...GlobalMessages.phoneNumberShort}
                        />
                      ),
                      value: practice.phoneNumber ? (
                        practice.phoneNumber
                      ) : (
                        <FormattedMessage {...GlobalMessages.unavailable} />
                      ),
                      disableIcon: true,
                      hideDeleteIcon: true,
                    },
                    {
                      label: <FormattedMessage {...GlobalMessages.email} />,
                      value: practice.email ? (
                        practice.email
                      ) : (
                        <FormattedMessage {...GlobalMessages.unavailable} />
                      ),
                      disableIcon: true,
                      id: "email",

                      hideDeleteIcon: true,
                    },
                  ],
                  [
                    {
                      label: "",
                      value: "",
                      disableIcon: true,
                      hideDeleteIcon: true,
                    },
                    {
                      label: (
                        <FormattedMessage {...GlobalMessages.houseNrShort} />
                      ),
                      value: practice.house_nr ? (
                        practice.house_nr
                      ) : (
                        <FormattedMessage {...GlobalMessages.unavailable} />
                      ),
                      disableIcon: true,
                      hideDeleteIcon: true,
                    },
                    {
                      label: <FormattedMessage {...GlobalMessages.city} />,
                      value: practice.city ? (
                        practice.city
                      ) : (
                        <FormattedMessage {...GlobalMessages.unavailable} />
                      ),
                      disableIcon: true,
                      hideDeleteIcon: true,
                    },
                    {
                      label: "",
                      value: "",
                      disableIcon: true,
                      hideDeleteIcon: true,
                    },
                    {
                      label: (
                        <FormattedMessage
                          {...GlobalMessages.emergencyPhoneNumberShort}
                        />
                      ),
                      value: practice.emergencyPhoneNumber ? (
                        practice.emergencyPhoneNumber
                      ) : (
                        <FormattedMessage {...GlobalMessages.unavailable} />
                      ),
                      disableIcon: true,
                      hideDeleteIcon: true,
                    },
                    {
                      label: "",
                      value: "",
                      disableIcon: true,
                      hideDeleteIcon: true,
                    },
                  ],
                  [
                    {
                      label: "",
                      value: "",
                      disableIcon: true,
                      hideDeleteIcon: true,
                    },
                    {
                      label: practice.house_nr_addendum ? (
                        <FormattedMessage
                          {...GlobalMessages.houseNrAddendumShort}
                        />
                      ) : (
                        ""
                      ),
                      value: practice.house_nr_addendum
                        ? practice.house_nr_addendum
                        : "",
                      disableIcon: true,
                      hideDeleteIcon: true,
                    },
                    {
                      label: "",
                      value: "",
                      disableIcon: true,
                      hideDeleteIcon: true,
                    },
                    {
                      label: "",
                      value: "",
                      disableIcon: true,
                      hideDeleteIcon: true,
                    },
                    {
                      label: "",
                      value: "",
                      disableIcon: true,
                      hideDeleteIcon: true,
                    },
                    {
                      label: "",
                      value: "",
                      disableIcon: true,
                      hideDeleteIcon: true,
                    },
                  ],
                ]}
              />
            </DataTableWrapper>
            <ChangeInformation style={{background:"white"}}>
              <Section>
                <FormattedMessage {...messages.changeInformation} />
              </Section>
              <Section2>
                <FormattedMessage {...messages.thenCallReFrezh} />
                <FormattedMessage
                  {...GlobalMessages.numberReFrezhNetherlands}
                />
              </Section2>
            </ChangeInformation>
          </Content>
        </Wrapper>
      </ComponentWrapper>
    );
  }
}

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const DataTableWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 10px;
`;

const InformationWrapper = styled.div`
  @media (min-width: 1270px) {
    margin-bottom: ${({ theme }) => theme.margin * 3}rem;
  }
`;

const Section = styled.div`
  // padding-top: ${({ theme }) => theme.padding}rem;
  //
  // @media (min-width: 1270px) {
  //   padding-top: ${({ theme }) => theme.padding * 2.5}rem;
  // }
`;

const Section2 = styled.div`
  padding-left: 1rem;
  // padding-top: ${({ theme }) => theme.padding}rem;
  // padding-bottom: ${({ theme }) => theme.padding}rem;
  //
  // @media (min-width: 1270px) {
  //   padding-top: ${({ theme }) => theme.padding * 2.5}rem;
  //   padding-bottom: 0px;
  // }
`;

const ChangeInformation = styled.div`
  display: flex;
  justify-content: center;
  border: 1px solid #acacac;

  border-radius: 0 0 10px 10px;

  padding: 5px;
  //margin-bottom: 1rem;
  //margin-top: 65px;

  //width: 100%;

  @media (min-width: 1270px) {
    width: 60%;
      transform: translateX(2%);


  }

  padding-left: ${({ theme }) => theme.padding}rem;

  @media (min-width: 1312px) {
    min-width: 160px;
    max-width: 160px;
  }

  @media (min-width: 1270px) {
    min-width: 120px;
    max-width: 160px;
  }

  //@media (min-width: 1271px) {
  //  min-width: 98%;
  //  max-width: 100%;
  //}

  // ${({ theme }) => theme.tabletPortraitUp`
  //   margin-top: ${theme.margin}rem;
  // `};

  @media (min-width: 1270px) {
    // margin-top: ${({ theme }) => theme.margin * 5}rem;
    //border-left: px;

    min-width: 96%;
    max-width: 96%;

    //border-radius: 0 0 10px 10px;
  }
  //
  // ${({ theme }) => theme.phone`
  //   margin-top: ${theme.margin}rem;
  //   min-width: 100% !important;
  //   max-width: 100% !important;
  // `};
`;

const Wrapper = styled.div`
  width: 100%;

  display: flex;
  ${({ theme }) => theme.phone`
    flex-direction: column;
  `};

  ${({ theme }) => theme.tabletPortraitUp`
    flex-direction: column;
  `};

  align-items: center;

  @media (min-width: 1270px) {
    flex-flow: row;
  }
`;

const Content = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: 1270px) {
    width: 100%;
  }

  ${({ theme }) => theme.phone`
    margin-top: ${theme.margin}rem;
    &:first-child {
      margin-top: 0;
    }
    width: 100%;
  `};
`;

export default PracticeInfo;
